import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { CircularProgress, Typography } from "@material-ui/core";
import DashboardPatient from "../dashboard/DashboardPatient";
import useUserState from "../hooks/useUserState";
import DriverMedicalCertificateRequestForm from "./DriverMedicalCertificateRequestForm";

export default function DriverMedicalCertificatePatientPage() {
  const [userState] = useUserState();
  const history = useHistory();
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchConfig() {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL_BASE}/driver-medical-certificate/config`,
          { headers: { Authorization: `Bearer ${userState?.jwt}` } }
        );
        setConfig(response.data);
      } catch (error) {
        setConfig({ enabled: false, price: 0 });
      } finally {
        setLoading(false);
      }
    }
    fetchConfig();
  }, [userState?.jwt]);

  if (loading) {
    return (
      <DashboardPatient>
        <CircularProgress />
      </DashboardPatient>
    );
  }

  if (!config?.enabled) {
    return (
      <DashboardPatient>
        <Typography variant="h6" style={{ padding: 24 }}>
          Esta función no está disponible por el momento.
        </Typography>
      </DashboardPatient>
    );
  }

  return (
    <DashboardPatient>
      <div style={{ padding: 24 }}>
        <DriverMedicalCertificateRequestForm
          mode="private"
          price={config.price}
          jwt={userState?.jwt}
          prefill={{
            full_name: `${userState?.extendedData?.firstName || ""} ${
              userState?.extendedData?.lastname || ""
            }`.trim(),
            document_number: userState?.extendedData?.identification || "",
            phone: userState?.extendedData?.phone || "",
            email: userState?.user?.email || "",
          }}
          onCompleted={() => history.push("/patient/dashboard")}
        />
      </div>
    </DashboardPatient>
  );
}
